module.exports = __webpack_public_path__ + "img/B252.8b4d2714.png";